(function () {
  angular.module("pcmCommon")
    .constant("optionsUI", {
      vehicleType: [
        {
          display: "Truck",
          value: 0
        },
        {
          display: "Light Truck",
          value: 1
        },
        {
          display: "Car",
          value: 2
        }
      ],
      cpVehicleType: [
        {
          display: "Car",
          value: 2
        },
        {
          display: "RV",
          value: 3
        },
        {
          display: "Motorcycle",
          value: 4
        },
        {
          display: "Bicycle",
          value: 5
        },
        {
          display: "Walking",
          value: 6
        }
      ],
      routingType: [
        {
          display: "Practical",
          value: 0
        },
        {
          display: "Shortest",
          value: 1
        },
        {
          display: "Fastest",
          value: 2
        }
      ],
      arrDepTypes: [
        {
          display: "None",
          value: "None"
        },
        {
          display: "Depart now",
          value: "now"
        },
        {
          display: "Depart at...",
          value: "Depart"
        },
        {
          display: "Arrive by...",
          value: "Arrive"
        }
      ],
      tollDiscourage: [
        {
          display: "Allowed",
          value: false
        },
        {
          display: "Discouraged",
          value: true
        }
      ],
      classOverrides: [
        {
          display: "None",
          value: 0
        },
        {
          display: "State + National Network",
          value: 3
        }
      ],
      highwayOnly: [
        {
          display: "Highways & Streets",
          value: false
        },
        {
          display: "Highway Only",
          value: true
        }
      ],
      bordersOpen: [
        {
          display: "Open",
          value: true
        },
        {
          display: "Closed",
          value: false
        }
      ],
      overrideRestrict: [
        {
          display: "Use",
          value: false
        },
        {
          display: "Override",
          value: true
        }
      ],
      ferryDiscourage: [
        {
          display: "Allowed",
          value: false
        },
        {
          display: "Discouraged",
          value: true
        }
      ],
      useSites: [
        {
          display: "Enabled",
          value: true
        },
        {
          display: "Disabled",
          value: false
        }
      ],
      hubRouting: [
        {
          display: "Disabled",
          value: false
        },
        {
          display: "Enabled",
          value: true
        }
      ],
      governorSpeedLimits: [
        {
          display: "Disabled",
          value: false
        },
        {
          display: "Enabled",
          value: true
        }
      ],
      elevLimit: [
        {
          display: "Any",
          value: false
        },
        {
          display: "Discouraged Above",
          value: true
        }
      ],
      cpTolls: [
        //{ display: "Always Avoid Tolls", value: true },
        {
          display: "Avoid Tolls if Possible",
          value: true
        },
        {
          display: "Tolls OK",
          value: false
        }
      ],
      distanceUnits: [
        {
          display: "Miles",
          value: 0
        },
        {
          display: "Kilometers",
          value: 1
        }
      ],
      fuelUnits: [
        {
          display: "Gallons",
          value: 0
        },
        {
          display: "Liters",
          value: 1
        }
      ],
      trkUnits: [
        {
          displayNA: "US Customary",
          displayEU: "English",
          value: 0
        },
        {
          displayNA: "Metric",
          displayEU: "Metric",
          value: 1
        }
      ],
      travelSpeeds: [
        {
          display: "Real-time Traffic",
          value: true
        },
        {
          display: "Historic Traffic",
          value: false
        }
      ],
      hazmat: [
        {
          display: "None",
          value: 0
        },
        {
          display: "Corrosive",
          value: 2
        },
        {
          display: "Explosives",
          value: 3
        },
        {
          display: "Flammable",
          value: 4
        },
        {
          display: "Inhalants",
          value: 5
        },
        {
          display: "Radioactive",
          value: 6
        },
        {
          display: "Other",
          value: 1
        }
      ],
      daydatetype: [
        {
          display: "Specific Day",
          value: "weekday"
        },
        {
          display: "Specific Date",
          value: "date"
        }
      ],
      tollCurrency: [
        {
          display: "US Dollars",
          value: 0,
          exchangeRate: 1.355,
          symbol: "$",
          isPrefix: true
        },
        {
          display: "Canadian Dollars",
          value: 1,
          exchangeRate: 0.738,
          symbol: "$",
          isPrefix: true
        }
      ],
      tollCurrencyEU:[
        {
          display: "Albanian lek",
          value: 2,
          exchangeRate: 1,
          symbol: "Lek",
          isPrefix: false
        },
        {
          display: "Aremenian dram",
          value: 3,
          exchangeRate: 1,
          symbol: "֏",
          isPrefix: true
        },
        {
          display: "Azerbaijani manat",
          value: 4,
          exchangeRate: 1,
          symbol: "₼",
          isPrefix: true
        },
        {
          display: "Bosnia and Herzegovina convertible mark",
          value: 5,
          exchangeRate: 1,
          symbol: "marks",
          isPrefix: false
        },
        {
          display: "Bulgarian lev",
          value: 6,
          exchangeRate: 1,
          symbol: "лв.",
          isPrefix: true
        },
        {
          display: "Belarusian ruble",
          value: 7,
          exchangeRate: 1,
          symbol: "rubles",
          isPrefix: false
        },
        {
          display: "Swiss franc",
          value: 8,
          exchangeRate: 1,
          symbol: "Fr.",
          isPrefix: true
        },
        {
          display: "Czech koruna",
          value: 9,
          exchangeRate: 1,
          Symbol: "Kč",
          isPrefix: false
        },
        {
          display: "Danish krone",
          value: 10,
          exchangeRate: 1,
          symbol: "kr.",
          isPrefix: true
        },
        {
          display: "Euros",
          value: 11,
          exchangeRate: 1,
          symbol: "€",
          isPrefix: true
        },
        {
          display: "Pound sterling",
          value: 12,
          exchangeRate: 1,
          symbol: "£",
          isPrefix: true
        },
        {
          display: "Georgian lari",
          value: 13,
          exchangeRate: 1,
          symbol: "GEL",
          isPrefix: true
        },
        {
          display: "Croatian kuna",
          value: 14,
          exchangeRate: 1,
          symbol: "kn",
          isPrefix: false
        },
        {
          display: "Hungarian forint",
          value: 15,
          exchangeRate: 1,
          symbol: "Ft",
          isPrefix: false
        },
        {
          display: "Icelandic króna: second króna",
          value: 16,
          exchangeRate: 1,
          symbol: "kr",
          isPrefix: true
        },
        {
          display: "Moldovan leu",
          value: 17,
          exchangeRate: 1,
          symbol: "lei",
          isPrefix: false
        },
        {
          display: "Second Macedonian denar",
          value: 18,
          exchangeRate: 1,
          symbol: "	ден",
          isPrefix: true
        },
        {
          display: "Norwegian krone",
          value: 19,
          exchangeRate: 1,
          symbol: "kr",
          isPrefix: true
        },
        {
          display: "Polish złoty",
          value: 20,
          exchangeRate: 1,
          symbol: "zł",
          isPrefix: true
        },
        {
          display: "Fourth Romanian leu",
          value: 21,
          exchangeRate: 1,
          symbol: "leu",
          isPrefix: false
        },
        {
          display: "Serbian dinar",
          value: 22,
          exchangeRate: 1,
          symbol: "din",
          isPrefix: false
        },
        {
          display: "Russian ruble",
          value: 23,
          exchangeRate: 1,
          symbol: "₽",
          isPrefix: false
        },
        {
          display: "Swedish krona",
          value: 24,
          exchangeRate: 1,
          symbol: "kr",
          isPrefix: true
        },
        {
          display: "Turkish lira",
          value: 25,
          exchangeRate: 1,
          symbol: "₺",
          isPrefix: true
        },
        {
          display: "Ukrainian hryvnia",
          value: 26,
          exchangeRate: 1,
          symbol: "₴",
          isPrefix: true
        }
      ],
      reportDataVersion: [
        {
          display: "Current",
          value: "current"
        },
        // Note: add here new data version is added.
        {
          display: "PC*MILER 37",
          value: "PCM37"
        },
        {
          display: "PC*MILER 36",
          value: "PCM36"
        },
        {
          display: "PC*MILER 35",
          value: "PCM35"
        },
        {
          display: "PC*MILER 34",
          value: "PCM34"
        },
        {
          display: "PC*MILER 33",
          value: "PCM33"
        },
        {
          display: "PC*MILER 32",
          value: "PCM32"
        },
        {
          display: "PC*MILER 31",
          value: "PCM31"
        },
        {
          display: "PC*MILER 30",
          value: "PCM30"
        },
        {
          display: "PC*MILER 29",
          value: "PCM29"
        },
        {
          display: "PC*MILER 28",
          value: "PCM28"
        },
        {
          display: "PC*MILER 27",
          value: "PCM27"
        },
        {
          display: "PC*MILER 26",
          value: "PCM26"
        },
        {
          display: "PC*MILER 25",
          value: "PCM25"
        },
        {
          display: "PC*MILER 24",
          value: "PCM24"
        },
        {
          display: "PC*MILER 23",
          value: "PCM23"
        },
        {
          display: "PC*MILER 22",
          value: "PCM22"
        },
        {
          display: "PC*MILER 21",
          value: "PCM21"
        },
        {
          display: "PC*MILER 20",
          value: "PCM20"
        },
        {
          display: "PC*MILER 19",
          value: "PCM19"
        },
        {
          display: "PC*MILER 18",
          value: "PCM18"
        }
      ],
      sideOfStreetAdherence: [
        {
          display: "Off",
          value: 0
        },
        {
          display: "Minimal",
          value: 1
        },
        {
          display: "Moderate",
          value: 2
        },
        {
          display: "Average",
          value: 3
        },
        {
          display: "Strict",
          value: 4
        },
        {
          display: "Adhere",
          value: 5
        },
        {
          display: "Strongly Adhere",
          value: 6
        }
      ],
      classicSearchView: [
        {
          display: "Separate Search Fields",
          value: true
        },
        {
          display: "Single Search Field",
          value: false
        }
      ],
      trlType: [
        {
          display: "None",
          value: 1
        },
        {
          display: "Caravan",
          value: 2
        },
        {
          display: "Trailer",
          value: 3
        }
      ],
      trlMaxAxles: [
        {
          display: 1,
          value: 1
        },
        {
          display: 2,
          value: 2
        },
        {
          display: 3,
          value: 3
        },
        {
          display: 4,
          value: 4
        },
        {
          display: 5,
          value: 5
        },
        {
          display: 6,
          value: 6
        },
        {
          display: 7,
          value: 7
        },
        {
          display: 8,
          value: 8
        }
      ],
      emiType: [
        {
          display: "Euro I",
          value: 3
        },
        {
          display: "Euro II",
          value: 4
        },
        {
          display: "Euro III",
          value: 5
        },
        {
          display: "Euro IV",
          value: 6
        },
        {
          display: "Euro V",
          value: 7
        },
        {
          display: "Euro VI",
          value: 8
        }
      ],
      trkAxles: [
        {
          display: 2,
          value: 2
        },
        {
          display: 3,
          value: 3
        },
        {
          display: 4,
          value: 4
        },
        {
          display: 5,
          value: 5
        },
        {
          display: 6,
          value: 6
        },
        {
          display: 7,
          value: 7
        },
        {
          display: 8,
          value: 8
        },
        {
          display: 9,
          value: 9
        },
        {
          display: 10,
          value: 10
        },
        {
          display: 11,
          value: 11
        },
        {
          display: 12,
          value: 12
        },
        {
          display: 13,
          value: 13
        },
        {
          display: 14,
          value: 14
        }
      ],
      euHazmatType : [{
        display: "None",
        value: "None"
      },
      {
        display: "General",
        value: "General"
      },
      {
        display: "Explosives",
        value: "Explosives"
      },
      {
        display: "Flammable",
        value: "Flammable"
      },
      {
        display: "Harmful to Water",
        value: "Harmful to Water"
      }
      ],
      euHazmatCat:[{
        display: "None",
        value: "None"
      },
      {
        display:"E Prohibited",
        value: "E Prohibited"
      },
      {
        display:"D, E Prohibited",
        value: "D, E Prohibited"
      },
      {
        display:"C, D, E Prohibited",
        value: "C, D, E Prohibited"
      },
      {
        display:"B, C, D, E Prohibited",
        value: "B, C, D, E Prohibited"
      }
      ],
      fuelType:[{
        display: "Petrol",
        value: 0
      },
      {
        display:"Petrol_E5",
        value: 1
      },
      {
        display:"Petrol_E10",
        value: 2
      },
      {
        display:"Ethanol",
        value: 3
      },
      {
        display:"Diesel",
        value: 4
      },
      {
        display:"Biodiesel",
        value: 5
      },
      {
        display:"Diesel_D5",
        value: 6
      },
      {
        display:"Diesel_D7",
        value: 7
      },
      {
        display:"Count",
        value: 8
      }
      ]
    });
})();



// WEBPACK FOOTER //
// ./app/pcm-common/optionsUI.module.js